import { useDroppable } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BlockContent } from './BlockContent';

export function SortableItem(props) {
  const {
    attributes,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isOver,
    over,
    isActive,
  } = useSortable({
    id: props.id,
    title: props.title,
    transition: null,
  });

  const { onRemove } = props;

  return (
    <div
      data-over={isOver}
      data-active={isActive}
      data-blockname={props.id}
      ref={setDroppableNodeRef}
      className="block-container"
      data-extended={props.extended}
      data-empty={props.empty}
    >
      <div className="block" ref={setDraggableNodeRef}>
        <button
          className="drag-thumb"
          ref={setActivatorNodeRef}
          {...attributes}
          {...listeners}
        ></button>
        <BlockContent id={props.id} title={props.title} onremove={onRemove} />
      </div>
    </div>
  );
}
